"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Up(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "3.946 13.304 5.361 14.718 12.068 8.011 5.361 1.304 3.946 2.718 9.239 8.011", transform: "scale(1 -1) rotate(90 16.018 0)" })));
}
exports.default = Up;
//# sourceMappingURL=Up.js.map